import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import vuetify from "./plugins/vuetify";
import axios from "./plugins/axios";
import "./plugins/leaflet";

import "./mixins/title";

const PRODUCTION = true;

export const API_HOST = PRODUCTION
  ? "https://api.fairfinder.app"
  : "http://127.0.0.1:3000";

Vue.config.productionTip = !PRODUCTION;
Vue.prototype.$apiHost = API_HOST;

Vue.prototype.$localStorageKeys = {
  CITY_ID: "FairFinder.cityId"
};

Vue.prototype.$navigateTo = function(routeName, routeParams) {
  if (routeParams == null) {
    routeParams = {
      cityId: this.$route.params.cityId
    };
  }

  this.$router.push({
    name: routeName,
    params: routeParams
  });
};

Vue.prototype.$parseImage = function(file) {
  return new Promise((resolve, reject) => {
    if (file != null) {
      let fileReader = new FileReader();

      fileReader.addEventListener("load", () => resolve(fileReader.result));
      fileReader.addEventListener("error", () =>
        reject(`Could not parse Image`)
      );

      fileReader.readAsDataURL(file);
    } else {
      resolve(null);
    }
  });
};

new Vue({
  router,
  store,
  vuetify,
  axios,
  render: h => h(App)
}).$mount("#app");
